import React from 'react';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import LoadingSpinner from '@arrive/loading-spinner';

import NoResults from 'components/NoResults/NoResults';

import LandingStyles from './LandingPage.scss';

interface CommittedCapacityLandingProps {
  onActionClick?: () => void;
  title?: string;
  icon: { id: string; viewBox: string };
  subTitle?: string;
  content?: string | React.ReactChild | React.ReactNode;
  actionText?: string;
  actionLinkTo?: string;
  className?: string;
  iconClass?: string;
  subTitleClass?: string;
  actionContent?: React.ReactChild;
}

interface CommittedCapacityLandingSpinnerProps {
  message: string
}

export function CommittedCapacityLandingPageSpinner({ message }: CommittedCapacityLandingSpinnerProps) {
  return (
    <LoadingSpinner
      className={LandingStyles.landingPageSpinner}
      savingText={message}
      theme='ethanol'
    />
  );
}

export default function CommittedCapacityLandingPage(props: CommittedCapacityLandingProps) {
  const { actionLinkTo, actionText, content, className, iconClass, subTitleClass, ...rest } = props;

  const customProps = {
    className: cx(LandingStyles.landingPageContainer, className),
    iconClass: cx(LandingStyles.landingPageIcon, iconClass),
    subTitleClass: cx(LandingStyles.landingPageTitle, subTitleClass)
  };

  return (
    <NoResults
      actionContent={
        <div className={LandingStyles.landingPageSeeDetails}>
          <Link to={actionLinkTo}>{actionText}</Link>
        </div>
      }
      content={<span className={LandingStyles.landingPageDescription}>{content}</span>}
      {...customProps}
      {...rest}
    />
  );
}

CommittedCapacityLandingPage.displayName = 'CommittedCapacityLandingPage';
